/* Stylesheet */

.cohort_segment {
  margin: 21px 4px 0px 4px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: var(--ion-box-shadow);

  .wrapper_container {
    padding: 21px;
  }
}
